'use client'

import Image from 'next/image'
import Link from 'next/link'

import { TProductOfWeek } from '@/screens/Home/page/types/types'
import { useGetPurchaseBonusesQuery } from '@/screens/Product/api/productApiSlice'

import { BASE_URL, PRODUCT_URL } from '@/shared/lib/const/env'
import { formatPrice } from '@/shared/lib/utils/price/format-price'

import cl from './WeeklyProductCard.module.scss'

type WeeklyProductCardProps = {
	product?: TProductOfWeek | null
}

export const WeeklyProductCard = ({ product }: WeeklyProductCardProps): JSX.Element | null => {
	const { data: bonusData } = useGetPurchaseBonusesQuery(
		{ productIds: product?.ID ? [product.ID] : [] },
		{
			skip: !product?.ACTIVE || !product?.ID
		}
	)

	if (!product?.ACTIVE) {
		return null
	}

	const { KOD, PRICE, OLD_PRICE, IMAGE, BOLD_SHORT_NAME, SMALL_SHORT_NAME } = product
	const href = `${PRODUCT_URL}${KOD}`

	const bonusPrice = bonusData?.data?.BONUS_PRICE
	const hasBonusDiscount = bonusPrice && bonusPrice < PRICE.VALUE

	let displayPrice = PRICE.VALUE
	let displayOldPrice: number | null = OLD_PRICE?.VALUE > PRICE.VALUE ? OLD_PRICE.VALUE : null

	if (hasBonusDiscount) {
		displayPrice = bonusPrice
		displayOldPrice = PRICE.VALUE
	}

	return (
		<div className={cl.wrapper}>
			<h2 className={cl.title}>Товар недели</h2>
			<Link prefetch={false} href={href} className={cl.link}>
				<div className={cl.imageWrapper}>
					<Image src={BASE_URL + IMAGE} alt={BOLD_SHORT_NAME} width={140} height={140} />
				</div>
				<div className={cl.textBlock}>
					<h2 className={cl.titleMobile}>Товар&nbsp;недели</h2>
					<h3 className={cl.name}>
						<span className={cl.nameBold}>{BOLD_SHORT_NAME}</span>
						<br />
						{SMALL_SHORT_NAME && <span className={cl.nameSmall}> {SMALL_SHORT_NAME}</span>}
					</h3>
					<div className={cl.priceBlock}>
						<span className={cl.price}>{formatPrice(displayPrice)}</span>
						<br />
						{displayOldPrice && <span className={cl.oldPrice}>{formatPrice(displayOldPrice)}</span>}
					</div>
				</div>
			</Link>
		</div>
	)
}
